var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seenotice"},[_c('h4',[_vm._v("标题")])])
}]

export { render, staticRenderFns }